export enum ErrorCode {
  NO_NEGOTIATION_STATUS_SELECTED,
}
